<template>
  <v-app id="UserMainte">
    <!-- ↓↓ユーザー管理 -->
    <v-dialog
      v-model="userAdminDialog"
      fullscreen
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="grey lighten-3"
        >
          <v-toolbar-title style="color: #3F51B5">
            ユーザー管理
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              color="#3F51B5"
              @click="$emit('closeUserAdminDialog')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-tabs v-model="tabs">
          <v-tab>自社ユーザー</v-tab>
          <v-tab>顧問先ユーザー</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card>
              <v-card-title>
                <v-spacer />
                <v-btn
                  color="primary"
                  @click="oCAddOwnUserDialog(true);"
                >
                  自社ユーザー招待
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="ownUsersHeaders"
                  :items="ownUsers"
                  :mobile-breakpoint="960"
                  no-data-text="データがありません。"
                  :footer-props="{
                    'items-per-page-options': [10, 20, 30, -1],
                    showFirstLastPage: true,
                  }"
                  :loading="usersLoading"
                >
                  <template v-slot:item.action="{ item }">
                    <v-btn
                      color="primary"
                      small
                      style="margin-right: 10px"
                      @click="ownUserEdit(item);"
                    >
                      編集
                    </v-btn>
                    <v-btn
                      v-if="user.cognito_user_name !== item.ownUserId"
                      color="gray"
                      small
                      @click.stop="deleteOwnUser(item)"
                    >
                      削除
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <v-card-title>
                <v-spacer />
                <v-btn
                  color="primary"
                  :loading="loadingAddPartUserDialog"
                  :disabled="loadingAddPartUserDialog"
                  @click.stop="$emit('createCompanyList'); oCAddPartUserDialog(true); !!$refs.addPartUserForm ? $refs.addPartUserForm.reset() : 0;"
                >
                  顧問先ユーザー招待
                </v-btn>
              </v-card-title>
              <v-data-table
                :headers="partUsersHeaders"
                :items="partUsers"
                :mobile-breakpoint="960"
                no-data-text="データがありません。"
                :footer-props="{
                  'items-per-page-options': [10, 20, 30, -1],
                  showFirstLastPage: true,
                }"
                :loading="usersLoading"
              >
                <template v-slot:item.action="{ item }">
                  <v-btn
                    color="primary"
                    small
                    style="margin-right: 10px"
                    @click="partUserEdit(item);"
                  >
                    編集
                  </v-btn>
                  <v-btn
                    color="gray"
                    small
                    @click.stop="deletePartUser(item)"
                  >
                    削除
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>

    <!-- ↓↓ユーザー管理-編集 -->
    <v-dialog
      v-model="ownUserEditDialog"
      max-width="500px"
      persistent
      :fullscreen="mobileFlg"
    >
      <v-card>
        <v-card-title>
          <span class="headline">自社ユーザー情報編集</span>
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="ownUserEditDialog = false; selectedCompanies = []; selectedCompaniesBefore = [];"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          ユーザーID、担当者名、メールアドレスはアカウント管理から本人のみが変更できます。
          <v-container>
            <v-row
              dense
              align="center"
            >
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-text-field
                  v-model="editedOwnUserItem.ownUserId"
                  label="ユーザーID"
                  disabled
                  readonly
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-text-field
                  v-model="editedOwnUserItem.ownName"
                  label="担当者名"
                  disabled
                  readonly
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedOwnUserItem.ownEmail"
                  label="メールアドレス"
                  disabled
                  readonly
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <span>権限</span>
                <v-select
                  v-model="editedOwnUserItem.ownLevel"
                  :items="['一般', '管理者']"
                  required
                  :disabled="user.cognito_user_name === editedOwnUserItem.ownUserId"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
                align="center"
              >
                <v-btn
                  v-if="editedOwnUserItem.ownLevel !== Constant.UserAuthTypeDisp.Admin"
                  color="gray"
                  @click.stop="$emit('createCompanyList'); openCloseOwnUserAuthDialog(true, false);"
                >
                  アクセス権設定
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="editedOwnUserItem.ownMFA"
                  :ripple="false"
                  :indeterminate="editedOwnUserItem.ownMFA === Constant.UserMfaDisp.Setting"
                  :true-value="Constant.UserMfaDisp.On"
                  :false-value="Constant.UserMfaDisp.Off || Constant.UserMfaDisp.Setting"
                  label="ワンタイムパスワード認証（スマートフォン必須）"
                />
              </v-col>
              <v-col cols="12">
                <v-card-text class="pt-0">
                  ワンタイムパスワード認証が無効の状態から有効へ変更すると、
                  本ユーザーへメールが送信されます。<br>
                  メールに記載のリンクからワンタイムパスワード認証の設定を完了することで
                  本ユーザーのワンタイムパスワード認証でのログインが有効になります。
                </v-card-text>
              </v-col>
              <mfa-description />
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            :loading="loadingOwnUserEdit"
            :disabled="loadingOwnUserEdit"
            @click="saveOwnUserEdit();"
          >
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="partUserEditDialog"
      max-width="500px"
      persistent
      :fullscreen="mobileFlg"
    >
      <v-card>
        <v-card-title>
          <span class="headline">顧問先ユーザー情報編集</span>
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="partUserEditDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          ユーザーID、担当者名、メールアドレスは本人のみが変更できます。
          <v-container>
            <v-row
              dense
              align="center"
            >
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-text-field
                  v-model="editedPartUserItem.partCompanyName"
                  label="顧問先名"
                  disabled
                  readonly
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-text-field
                  v-model="editedPartUserItem.partUserId"
                  label="ユーザーID"
                  disabled
                  readonly
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-text-field
                  v-model="editedPartUserItem.partName"
                  label="担当者名"
                  disabled
                  readonly
                />
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-text-field
                  v-model="editedPartUserItem.partEmail"
                  label="メールアドレス"
                  disabled
                  readonly
                />
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="editedPartUserItem.partMFA"
                  :ripple="false"
                  :indeterminate="editedPartUserItem.partMFA === Constant.UserMfaDisp.Setting"
                  :true-value="Constant.UserMfaDisp.On"
                  :false-value="Constant.UserMfaDisp.Off || Constant.UserMfaDisp.Setting"
                  label="ワンタイムパスワード認証（スマートフォン必須）"
                />
              </v-col>
              <v-col cols="12">
                <v-card-text class="pt-0">
                  ワンタイムパスワード認証が無効の状態から有効へ変更すると、
                  本ユーザーへメールが送信されます。<br>
                  メールに記載のリンクからワンタイムパスワード認証の設定を完了することで
                  本ユーザーのワンタイムパスワード認証でのログインが有効になります。
                </v-card-text>
              </v-col>
              <mfa-description />
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            :loading="loadingPartUserEdit"
            :disabled="loadingPartUserEdit"
            @click="savePartUserEdit()"
          >
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ↓↓ ユーザー管理-アクセス権フォルダ指定 -->
    <v-dialog
      v-model="ownUserAuthDialog"
      width="500"
      persistent
      scrollable
      :fullscreen="mobileFlg"
    >
      <v-card
        style="overflow-y:auto"
        max-width="500"
      >
        <v-card-title>
          <span class="headline">アクセス権設定</span>
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="openCloseOwnUserAuthDialog(false, false);"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <span style="margin-left:20px">本ユーザーのアクセス権を設定できます。</span>
          <v-container>
            <v-row align="end">
              <v-col
                cols="12"
                sm="2"
                md="2"
              >
                <v-btn
                  color="primary"
                  @click="selectAllCompanies();"
                >
                  全選択
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
              >
                <v-btn
                  color="grey lighten-3"
                  @click="selectedCompanies = [];"
                >
                  全解除
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                sm="8"
                md="8"
              >
                <v-text-field
                  v-model="searchCompaniesTree"
                  label="ここに入力して絞込"
                  single-line
                  clearable
                  hide-details
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                style="height: 100%; overflow:auto;"
              >
                <v-treeview
                  v-model="selectedCompanies"
                  :items="companies"
                  :search="searchCompaniesTree"
                  selection-type="independent"
                  selectable
                  selected-color="primary"
                  dense
                >
                  <template v-slot:append="{ item }">
                    <v-btn
                      v-if="item.children.length > 0"
                      color="primary"
                      small
                      @click="selectAllChildCompanies(item);"
                    >
                      全選択
                    </v-btn>
                    <v-btn
                      v-if="item.children.length > 0"
                      color="grey lighten-3"
                      small
                      @click="clearAllChildCompanies(item);"
                    >
                      全解除
                    </v-btn>
                  </template>
                </v-treeview>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="openCloseOwnUserAuthDialog(false, true);"
          >
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ↑↑ユーザー管理-アクセス権フォルダ指定 -->
    <!-- ↓↓歯車から-アクセス権ユーザー指定 -->
    <v-dialog
      v-model="ownUserAuthUserDialog"
      width="600"
      persistent
      :fullscreen="iPhoneFlg"
    >
      <v-card
        id="ownUserAuthUserCard"
        style="overflow-y:auto;"
        max-width="600"
      >
        <v-card-title>
          <span class="headline">アクセス権設定</span>
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="oCOwnUserAuthUserDialog(false);"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-3 px-4">
          対象フォルダーへのアクセス権を設定してください。
        </v-card-text>
        <v-card-text
          v-if="selectedCompany !== null"
          class="pb-3 px-4"
        >
          対象フォルダー：{{ selectedCompany.name }}
        </v-card-text>
        <v-card-text class="pa-0">
          <v-tabs
            v-model="authTabs"
            background-color="grey lighten-4"
          >
            <v-tab>自社ユーザー</v-tab>
            <v-tab>顧問先ユーザー</v-tab>
          </v-tabs>
          <v-tabs-items v-model="authTabs">
            <v-tab-item>
              <v-col
                class="py-0"
                cols="12"
                sm="12"
                md="12"
              >
                <v-text-field
                  v-model="searchUsersTable"
                  class="pt-0"
                  label="ここに入力して絞込"
                  single-line
                  clearable
                  hide-details
                />
              </v-col>
              <v-data-table
                v-model="selectedUsers"
                :headers="ownUserAuthUserHeaders"
                :items="ownUsers"
                :search="searchUsersTable"
                no-data-text="ユーザーがいません"
                no-results-text="該当するユーザーがいません"
                item-key="ownUserUuId"
                show-select
                :height="iPhoneFlg ? iPhoneTableHeight : 530"
                :mobile-breakpoint="960"
                :return-object="false"
                class="elevation-1"
                :footer-props="{
                  'items-per-page-options': [10, 20, 30, -1],
                  showFirstLastPage: true,
                }"
              />
            </v-tab-item>
            <v-tab-item>
              <v-col
                class="py-0"
                cols="12"
                sm="12"
                md="12"
              >
                <v-text-field
                  v-model="searchPartUsersTable"
                  class="pt-0"
                  label="ここに入力して絞込"
                  single-line
                  clearable
                  hide-details
                />
              </v-col>
              <v-data-table
                v-model="selectedPartUsers"
                :headers="partUserAuthUserHeaders"
                :items="partUsers"
                :search="searchPartUsersTable"
                no-data-text="ユーザーがいません"
                no-results-text="該当するユーザーがいません"
                item-key="partUserUuId"
                show-select
                :height="iPhoneFlg ? iPhoneTableHeight : 530"
                :mobile-breakpoint="960"
                :return-object="false"
                class="elevation-1"
                :footer-props="{
                  'items-per-page-options': [10, 20, 30, -1],
                  showFirstLastPage: true,
                }"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            :loading="loadingOwnUserAuth"
            :disabled="loadingOwnUserAuth"
            @click="saveUserAuthUser();"
          >
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ↑↑歯車から-アクセス権ユーザー指定 -->

    <!-- ↑↑ユーザー管理-編集 -->

    <!-- ↓↓自社ユーザー追加 -->
    <v-dialog
      v-model="addOwnUserDialog"
      :persistent="true"
      width="500"
      :fullscreen="mobileFlg"
    >
      <v-card>
        <v-card-title primary-title>
          自社ユーザー招待
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="$refs.addOwnUserForm.reset(); oCAddOwnUserDialog(false); selectedCompanies = [];"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          入力したメールアドレスへ招待メールを送信します。
          <br>招待メールに記載のURLからユーザー登録を行っていただくことで
          <br>正式にユーザーとして追加されます。
        </v-card-text>
        <v-container>
          <v-col
            cols="12"
            sm="12"
            md="12"
          >
            <v-form
              ref="addOwnUserForm"
              v-model="valid"
              lazy-validation
              @submit.prevent
            >
              <v-text-field
                v-model="addOwnUserEmail"
                style="white-space:pre-line; word-wrap:break-word;"
                label="メールアドレス(※)"
                counter="256"
                maxlength="256"
                required
                :rules="[v => !!v || 'メールアドレスは必須です',
                         v => /[^\s]+@[^\s]+/.test(v) || 'メールアドレスが正しくありません']"
                hint="「no-reply@wd.weplat.epson.jp」からメールが届きます。受信先で迷惑メールフィルタを設定している場合には、このメールアドレスの受信を許可してください。"
              />
              <v-select
                v-model="addOwnUserAuth"
                :items="['管理者', '一般']"
                label="権限(※)"
                required
                :rules="[v => !!v || '権限は必須です']"
              />
              <v-btn
                v-if="addOwnUserAuth !== Constant.UserAuthTypeDisp.Admin"
                color="gray"
                @click.stop="$emit('createCompanyList'); openCloseOwnUserAuthDialog(true, false);"
              >
                アクセス権設定(※)
              </v-btn>
              <v-checkbox
                v-model="addOwnUserMfaflg"
                :ripple="false"
                :label="`ワンタイムパスワード認証を有効にする（スマートフォン必須）`"
              />
            </v-form>
            <mfa-description />
          </v-col>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :loading="loadingAddOwnUser"
            :disabled="loadingAddOwnUser"
            @click="addOwnUser();"
          >
            送信
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ↑↑自社ユーザー追加 -->
    <!-- ↓↓顧問先ユーザー追加 -->
    <v-dialog
      v-model="addPartUserDialog"
      :persistent="true"
      width="500"
      :fullscreen="mobileFlg"
    >
      <v-card>
        <v-card-title primary-title>
          顧問先ユーザー招待
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="oCAddPartUserDialog(false); $refs.addPartUserForm.reset(); loadingAddPartUserDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          入力したメールアドレスへ招待メールを送信します。
          <br>招待メールに記載のURLからユーザー登録を行っていただくことで
          <br>正式にユーザーとして追加されます。
        </v-card-text>
        <v-container>
          <v-col
            cols="12"
            sm="12"
            md="12"
          >
            <v-form
              ref="addPartUserForm"
              v-model="valid"
              lazy-validation
              @submit.prevent
            >
              <v-autocomplete
                ref="addPartUserCompany"
                v-model="addPartUserCompany"
                :items="firstCompanies"
                item-text="name"
                item-value="id"
                :rules="[v => !!v || '顧問先は必須です']"
                label="招待顧問先(※)"
                no-data-text="顧問先が存在しません"
                required
                hint="文字入力で顧問先を絞り込むことができます"
              />
              <v-text-field
                v-model="addPartUserEmail"
                style="white-space:pre-line; word-wrap:break-word;"
                label="メールアドレス(※)"
                counter="256"
                maxlength="256"
                required
                :rules="[v => !!v || 'メールアドレスは必須です',
                         v => /[^\s]+@[^\s]+/.test(v) || 'メールアドレスが正しくありません']"
                hint="「no-reply@wd.weplat.epson.jp」からメールが届きます。受信先で迷惑メールフィルタを設定している場合には、このメールアドレスの受信を許可してください。"
              />
              <v-checkbox
                v-model="addPartUserMfaflg"
                :ripple="false"
                :label="`ワンタイムパスワード認証を有効にする（スマートフォン必須）`"
              />
            </v-form>
            <mfa-description />
          </v-col>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            :loading="loadingAddPartUser"
            :disabled="loadingAddPartUser"
            @click="addPartUser();"
          >
            送信
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ↑↑顧問先ユーザー追加 -->

    <!-- ↓↓削除確認ダイアログ -->
    <v-dialog
      v-model="checkDeleteDialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title primary-title>
          本当に削除しますか？
          <v-spacer />
          <v-btn
            icon
            large
            color="#3F51B5"
            @click="deleteCancel"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          削除後は元に戻すことはできません。<br>
          削除後は削除したユーザーへメールで通知されます。
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="deleteCancel"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="deleteOk"
          >
            確定
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ↑↑削除確認ダイアログ -->
    <!-- ↓↓ オーバーレイローディング-->
    <v-overlay
      :value="overlayUser"
      z-index="10000"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <!-- ↑↑ オーバーレイローディング-->
    <msg-dlg ref="MsgDlg" />
  </v-app>
</template>

<script>
import Vue from "vue";
import MsgDlg from "../MsgDlg.vue";
import Amplify, {Queries, Mutations, GraphqlUtil, Uuid, Constant, Logger, isMobile} from '../../amplify_com.js';
import MfaDescription from '../MfaDescription.vue';

export default {
  components: {
    "msg-dlg": MsgDlg,
    "mfa-description": MfaDescription, 
  },
  props: {
    userAdminDialog: {
      type: Boolean,
      default: false
    },
    addOwnUserDialog: {
      type: Boolean,
      default: false
    },
    addPartUserDialog: {
      type: Boolean,
      default: false
    },
    ownUserAuthUserDialog: {
      type: Boolean,
      default: false
    },
    firstCompanies: {
      type: Array,
      default: null
    },
    companies: {
      type: Array,
      default: null
    },
    selectedCompany: {
      type: Object,
      default: null
    },
    selectedFirstCompanyName: {
      type: String,
      default: ""
    },
    user: {
      type: Object,
      default: null
    }

  },
  data: () => ({
    Constant :Constant, // template内で定数クラスを使用するため
    mobileFlg: isMobile.any,
    iPhoneFlg: isMobile.apple.phone,
    iPhoneTableHeight: null,
    valid: null,
    ownUserAuthDialog: false,
    ownUserEditDialog: false,
    partUserEditDialog: false,
    checkDeleteDialog: false,
    usersLoading: false,
    tabs: null,
    authTabs: null,
    //ボタン制御系
    overlayUser: false,
    loadingAddPartUserDialog: false,
    loadingAddOwnUser: false,
    loadingAddPartUser: false,
    loadingOwnUserEdit: false,
    loadingPartUserEdit: false,
    loadingOwnUserAuth: false,

    //自社ユーザー追加用
    addOwnUserEmail: "",
    addOwnUserAuth: "",
    addOwnUserMfaflg: "",
    //顧問先ユーザー追加用
    addPartUserCompany: "",
    addPartUserEmail: "",
    addPartUserMfaflg: "",
    addPartCompanyList: [],
    //自社ユーザーヘッダー
    ownUsersHeaders: [
      { text: "ユーザーID", value: "ownUserId" },
      { text: "担当者名", value: "ownName" },
      { text: "メールアドレス", value: "ownEmail" },
      { text: "権限", value: "ownLevel", width:"75px" },
      { text: "ワンタイムパスワード認証", value: "ownMFA", width:"100px" },
      { text: "操作", value: "action", sortable: false, width:"147px" }
    ],
    //自社ユーザー一覧（本来はAPIで取得）
    ownUsers: [],
    //顧問先ユーザー一覧ヘッダー
    partUsersHeaders: [
      { text: "顧問先名", value: "partCompanyName"},
      { text: "ユーザーID", value: "partUserId"},
      { text: "担当者名", value: "partName"},
      { text: "メールアドレス", value: "partEmail" ,},
      { text: "ワンタイムパスワード認証", value: "partMFA", width:"100px"},
      { text: "操作", value: "action", sortable: false, width:"147px" }
    ],
    //顧問先ユーザ一一覧（本来はAPIで取得）
    partUsers: [],
    //編集用
    editedOwnUserItem: {
      ownUserId: "",
      ownName: "",
      ownEmail: "",
      ownLevel: "",
      ownCompany: "",
      ownMFA: "",
      ownPreUpdMFA: "",
    },
    editedPartUserItem: {
      partCompanyName: "",
      partUserUuId: "",
      partUserId: "",
      partName: "",
      partEmail: "",
      partMFA: "",
      partPreUpdMFA: "",
    },
    //アクセス権（フォルダ単位）
    selectedCompanies: [],
    selectedCompaniesBefore: [],
    searchCompaniesTree: "",
    //アクセス権（メンバー単位）
    selectedUsers: [],
    selectedPartUsers: [],
    searchUsersTable: "",
    searchPartUsersTable: "",
  }),
  computed: {
    ownUserAuthUserHeaders() {
      return [
        { text: "ユーザーID", value: "ownUserId" },
        { text: "担当者名", value: "ownName" },
        { text: "権限", value: "ownLevel",
          filter: value => {
            return value !== Constant.UserAuthTypeDisp.Admin
          },
        }
      ]
    },
    partUserAuthUserHeaders() {
      return [
        { text: "顧問先名",
          value: "partCompanyName",
          filter: value => {
            return value === this.selectedFirstCompanyName
          }
        },
        { text: "ユーザーID", value: "partUserId" },
        { text: "担当者名", value: "partName" },
      ];
    }
  },
  watch:{
    selectedCompanies: function (newVal, oldVal) {
       Logger.log(newVal,oldVal);
    },
  },
  methods: {
    // 他社ユーザも含めてユーザ一覧取得(管理者用)
    getUsersByAdmin: async function(){
      let _this = this;
      
      // 紹介元会社の管理者のみAPIに接続
      if(_this.user.type === Constant.UserType.Host && _this.user.auth === Constant.UserAuthType.Admin){
        //ローディング描画
        this.usersLoading = true;

        // ログイン情報からユーザ一覧取得
        let _result = null;
        await GraphqlUtil.exec(Queries.GetUsers, null).then(result => {
          _result = result;
        }).catch(error => {
          _result = null;
          this.usersLoading = false;
          _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        });

        if(!_result){
          this.usersLoading = false;
          return;
        }
        //初期化
        this.ownUsers = [];
        this.partUsers = [];

        // 自ユーザー 一覧更新
        var i = 0;
        for(i = 0; i < _result.data.GetUsers.own_users.length; i++){
          var tmp_own_user = _result.data.GetUsers.own_users[i];
          const ownUser = {
            ownUserId: tmp_own_user.preferred_user_name ? tmp_own_user.preferred_user_name : tmp_own_user.user_name,
            ownUserUuId: tmp_own_user.user_id,
            ownName: tmp_own_user.disp_name,
            ownEmail: tmp_own_user.email,
            ownLevel: parseInt(tmp_own_user.auth_type) === Constant.UserAuthType.Admin ? Constant.UserAuthTypeDisp.Admin : Constant.UserAuthTypeDisp.General,
            ownMFA: this.mfaFlgToDisp(tmp_own_user.mfa_type),
            ownPreUpdMFA: this.mfaFlgToDisp(tmp_own_user.mfa_type), 
          };
          _this.ownUsers.push(ownUser);
        }

        // 他社ユーザー 一覧更新
        for(i = 0; i < _result.data.GetUsers.part_users.length; i++){
          var tmp_user = _result.data.GetUsers.part_users[i];
          const partUser = {
            partUserUuId: tmp_user.user_id,
            partCompanyName: tmp_user.company_disp_name,
            partUserId: tmp_user.preferred_user_name ? tmp_user.preferred_user_name : tmp_user.user_name,
            partName: tmp_user.disp_name,
            partEmail: tmp_user.email,
            partMFA: this.mfaFlgToDisp(tmp_user.mfa_type),
            partPreUpdMFA: this.mfaFlgToDisp(tmp_user.mfa_type), 
          };
          _this.partUsers.push(partUser);
        }
        this.usersLoading = false;
      }
    },
    //ユーザー編集（管理者）
    ownUserEdit: async function(item) {
      this.overlayUser = true;
      this.editedOwnUserItem = Vue.util.extend({}, item);
      //フォルダ権限取得
      await this.getUserAuthFolder();
      this.ownUserEditDialog = true;
      this.overlayUser = false;
    },
    saveOwnUserEdit: async function(){
      if(this.selectedCompanies.length === 0 && this.addOwnUserAuth !== Constant.UserAuthTypeDisp.Admin){
        this.$refs.MsgDlg.showError("アクセス権を設定してください");
        return;
      }
      //ボタン無効化
      this.loadingOwnUserEdit = true;

      let _this = this;
      //管理者でなければアクセス権を保存
      if(_this.editedOwnUserItem.ownLevel !== Constant.UserAuthTypeDisp.Admin){
        //フォルダアクセス権の保存
        await _this.saveUserAuthFolder();
      }
      // ユーザー更新
      var mfa_type = _this.mfaDispToFlg(_this.editedOwnUserItem.ownMFA);
      var pre_upd_mfa_type = _this.mfaDispToFlg(_this.editedOwnUserItem.ownPreUpdMFA);
      var auth_type = Constant.UserAuthTypeDisp.Admin ===  _this.editedOwnUserItem.ownLevel ? Constant.UserAuthType.Admin : Constant.UserAuthType.General;
      await _this.saveUserByAdmin(_this.editedOwnUserItem.ownUserUuId, mfa_type, pre_upd_mfa_type, auth_type).then(result => {
        var tmp_own_user = result.data.UpdateUser;
        // 無効から有効に切り替えた場合
        if(pre_upd_mfa_type === Constant.UserMfa.Off && mfa_type === Constant.UserMfa.On){
          tmp_own_user.mfa_type = Constant.UserMfa.Setting;
        }
        // ユーザー管理画面の一覧に反映
        var checkedIndex = _this.ownUsers.findIndex((e) => e.ownUserUuId === tmp_own_user.user_id);
        if(_this.ownUsers[checkedIndex]){
          _this.ownUsers[checkedIndex].ownLevel = parseInt(tmp_own_user.auth_type) === Constant.UserAuthType.Admin ? Constant.UserAuthTypeDisp.Admin : Constant.UserAuthTypeDisp.General;
          _this.ownUsers[checkedIndex].ownMFA = _this.mfaFlgToDisp(tmp_own_user.mfa_type);
          _this.ownUsers[checkedIndex].ownPreUpdMFA = _this.ownUsers[checkedIndex].ownMFA;
        }

        //ダイアログを閉じる
        _this.ownUserEditDialog = false;
        _this.loadingOwnUserEdit = false;
      }).catch(error => {
        // 共通関数内部でエラーダイアログを表示しているので何もしない
        _this.loadingOwnUserEdit = false;
        Logger.log(error);
      });
    },
    partUserEdit(item) {
      this.overlayUser = true;
      this.editedPartUserItem = Vue.util.extend({}, item);
      this.partUserEditDialog = true;
      this.overlayUser = false;
    },
    savePartUserEdit: async function(){
      //ボタン無効化
      this.loadingPartUserEdit = true;

      let _this = this;
      // 顧問先ユーザー更新
      var mfa_type = _this.mfaDispToFlg(_this.editedPartUserItem.partMFA);
      var pre_upd_mfa_type = _this.mfaDispToFlg(_this.editedPartUserItem.partPreUpdMFA);
      await _this.saveUserByAdmin(_this.editedPartUserItem.partUserUuId, mfa_type, pre_upd_mfa_type, Constant.UserAuthType.General).then(result => {
        var tmp_user = result.data.UpdateUser;
        // 無効から有効に切り替えた場合
        if(pre_upd_mfa_type === Constant.UserMfa.Off && mfa_type === Constant.UserMfa.On){
          tmp_user.mfa_type = Constant.UserMfa.Setting;
        }
        // ユーザー管理画面の一覧に反映
        var checkedIndex = _this.partUsers.findIndex((e) => e.partUserUuId === tmp_user.user_id);
        if(_this.partUsers[checkedIndex]){
          _this.partUsers[checkedIndex].partMFA = _this.mfaFlgToDisp(tmp_user.mfa_type);
          _this.partUsers[checkedIndex].partPreUpdMFA = _this.partUsers[checkedIndex].partMFA;
        }

        //ダイアログを閉じる
        _this.partUserEditDialog = false;
        _this.loadingPartUserEdit = false;
      }).catch(error => {
        // 共通関数内部でエラーダイアログを表示しているので何もしない
        _this.loadingPartUserEdit = false;
        Logger.log(error);
      });
    },
    //ワンタイムパスワード認証フラグを表示用に変換
    mfaFlgToDisp(UserMfa){
      var mfaDisp = "";
      if(UserMfa === Constant.UserMfa.On){
        mfaDisp = Constant.UserMfaDisp.On;
      }else if(UserMfa === Constant.UserMfa.Off){
        mfaDisp = Constant.UserMfaDisp.Off;
      }else if(UserMfa === Constant.UserMfa.Setting){
        mfaDisp = Constant.UserMfaDisp.Setting;
      }
      return mfaDisp;
    },
    //ワンタイムパスワード認証表示用をフラグに変換
    mfaDispToFlg(UserMfaDisp){
      var mfaFlg = "";
      if(UserMfaDisp === Constant.UserMfaDisp.On){
        mfaFlg = Constant.UserMfa.On;
      }else if(UserMfaDisp === Constant.UserMfaDisp.Off){
        mfaFlg = Constant.UserMfa.Off;
      }else if(UserMfaDisp === Constant.UserMfaDisp.Setting){
        mfaFlg = Constant.UserMfa.Setting;
      }
      return mfaFlg;
    },
    oCAddOwnUserDialog(flg){
      this.$emit('openCloseAddOwnUserDialog', flg);
    },
    oCAddPartUserDialog(flg){
      if(flg){
        this.loadingAddPartUserDialog = true;
        setTimeout(() => {
        //連打対策
          this.loadingAddPartUserDialog = false;
        }, 2000);
      }
      this.$emit("openCloseAddPartUserDialog", flg);
    },
    oCOwnUserAuthUserDialog(flg){
      this.$emit('openCloseOwnUserAuthUserDialog', flg);
      if(this.iPhoneFlg){
        //iPhoneの場合のみ実行する
        if(flg){
          setTimeout(() => {
            this.setHeightOwnUserAuthUserTable();
          }, 300);
        }else{
          setTimeout(() => {
            this.iPhoneTableHeight = null;
          }, 300);
        }
      }
    },
    //iPhone用メソッド フォルダアクセス権設定テーブルheightを設定する
    setHeightOwnUserAuthUserTable(){
      const element = document.getElementById('ownUserAuthUserCard');
      if(element){
        let windowHeight = window.innerHeight; //ブラウザの表示領域高さを取得する
        let height = windowHeight - 370; //370はテーブル以外のheight合計 ※次版で要確認
        this.iPhoneTableHeight = height; //テーブルに算出した高さを設定する
      }
    },
    //1ユーザーのフォルダアクセス権を取得(ユーザー管理からのアクセス権設定)
    getUserAuthFolder: async function(){
      let _this = this;
      this.selectedCompanies = [];
      //×ボタン時の切り戻し用
      this.selectedCompaniesBefore = [];
      
        // ユーザーから権限取得 
        const param = {
          user_id: _this.editedOwnUserItem.ownUserUuId,
        }
        await GraphqlUtil.exec(Queries.GetAuths, param).then(result => {
          for(var i = 0; i < result.data.GetAuths.length; i++){
            var auth = result.data.GetAuths[i];
            this.selectedCompanies.push(auth.fold_id);
            this.selectedCompaniesBefore.push(auth.fold_id);
          }
        }).catch(error => {
          Logger.log(error);
          _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        });
    },
    //1ユーザーのフォルダアクセス権を保存(ユーザー管理からのアクセス権設定)
    saveUserAuthFolder: async function(){
        // ユーザーにフォルダアクセス権限を追加
        const param = {
          user_id: this.editedOwnUserItem.ownUserUuId,
          fold_ids : this.selectedCompanies,
        }
        Logger.log(param);
        let _result = null;
        await GraphqlUtil.exec(Mutations.UpdateUserAuths, {input:param}).then(result => {
          _result = result;
          Logger.log(result);
        }).catch(error => {
          _result = null;
          Logger.log(error);
          this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        });

        if(!_result){
          return;
        }
        //初期化する
        this.selectedCompanies = [];
        this.selectedCompaniesBefore = [];

        //フォルダ一覧を最新化する
        this.$emit('setLatestFoldData');
    },
    saveUserByAdmin: async function(user_id, mfa_type, pre_upd_mfa_type, auth_type){
      // 管理者ーユーザからユーザー情報を変更
      const updateUserInput = {
        user_id: user_id,
        mfa_type : mfa_type,
        auth_type : auth_type,
      }
      Logger.log(updateUserInput);
      let _result = null;
      let _err = null;
      await GraphqlUtil.exec(Mutations.UpdateUser, {input:updateUserInput}).then(result => {
        _result = result;
        _err = null;
      }).catch(error => {
        _result = null;
        _err = error;
      });

      if(!_result){
        this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(_err));
        throw _err;
      }

      // 無効から有効に切り替えた場合
      if(pre_upd_mfa_type === Constant.UserMfa.Off && mfa_type === Constant.UserMfa.On ||
          pre_upd_mfa_type === Constant.UserMfa.Setting && mfa_type === Constant.UserMfa.On
        ){
        this.$refs.MsgDlg.showSuccess('ワンタイムパスワード認証設定のメールを送信しました。');
      }
      return _result;
    },
    //1つのフォルダのアクセス権を取得（歯車からのアクセス権設定）
    getUserAuthUser: async function(fold_flg){
      //ユーザー一覧を取得
      await this.getUsersByAdmin();
      
      let _this = this;
      this.selectedUsers = [];
      this.selectedPartUsers = [];
      if(fold_flg){
        // フォルダから権限取得
        const param = {
          fold_id: _this.selectedCompany.id,
        }
        let _result = null;
        await GraphqlUtil.exec(Queries.GetAuths, param).then(result => {
          _result = result;
          //自社ユーザー
          for(var i = 0; i < result.data.GetAuths.length; i++){
            var auth = result.data.GetAuths[i];
            var checkedIndexOwn = this.ownUsers.findIndex((e) => e.ownUserUuId === auth.user_id);
            if(checkedIndexOwn !== -1){
              this.selectedUsers.push(this.ownUsers[checkedIndexOwn]);
            }
          }
          //顧問先ユーザー
          for(i = 0; i < result.data.GetAuths.length; i++){
            auth = result.data.GetAuths[i];
            var checkedIndexPart = this.partUsers.findIndex((e) => e.partUserUuId === auth.user_id);
            if(checkedIndexPart !== -1){
              this.selectedPartUsers.push(this.partUsers[checkedIndexPart]);
            }
          }
        }).catch(error => {
          _result = null;
          Logger.log(error);
          _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        });

        if(!_result){
          return;
        }
        this.oCOwnUserAuthUserDialog(true);
      } 
    },
    //1つのフォルダのアクセス権を保存（歯車からのアクセス権設定）
    saveUserAuthUser: async function(){
      //ボタン無効化
      this.loadingOwnUserAuth = true;
        let user_ids = [];
        // チェックを入れたユーザ一覧取得（自社ユーザー）
        for(var i = 0; i < this.selectedUsers.length; i++) {
          var ownUser = this.selectedUsers[i];
          user_ids.push(ownUser.ownUserUuId);
        }
        // チェックを入れたユーザ一覧取得（顧問先ユーザー）
        for(i = 0; i < this.selectedPartUsers.length; i++) {
          var partUser = this.selectedPartUsers[i];
          user_ids.push(partUser.partUserUuId);
        }
        // フォルダにユーザー権限を追加
        const param = {
          fold_id: this.selectedCompany.id,
          user_ids : user_ids,
        }
        Logger.log(param);
        let _result = null;
        await GraphqlUtil.exec(Mutations.UpdateFoldAuths, {input:param}).then(result => {
            _result = result;
            Logger.log(result);
        }).catch(error => {
            _result = null;
            Logger.log(error);
            this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
            this.loadingOwnUserAuth = false;
        });

        if(!_result){
          this.loadingOwnUserAuth = false;
          return;
        }

        //初期化しダイアログを閉じる
        this.selectedUsers = [];
        this.selectedPartUsers = [];
        this.oCOwnUserAuthUserDialog(false);
        setTimeout(() => {
          //連打対策（ダイアログが閉じる前に一瞬有効化されてしまうため解除を遅らせる）
          this.loadingOwnUserAuth = false;
        }, 500);
        //フォルダ一覧を最新化する
        this.$emit('setLatestFoldData');
    },
    // 自社ユーザ単位のアクセス権設定画面 オープン、クローズ
    openCloseOwnUserAuthDialog: async function(flg, commit){
      if(commit){
        // 確定ボタンからの遷移
        if(this.selectedCompanies.length === 0 && this.addOwnUserAuth !== Constant.UserAuthTypeDisp.Admin){
          this.$refs.MsgDlg.showError("アクセス権を設定してください");
          return;
        }
        this.selectedCompaniesBefore = this.selectedCompanies.slice();
      }else if(!flg && !commit){
        //×ボタンからの遷移
        this.selectedCompanies = this.selectedCompaniesBefore.slice();
      }
      this.ownUserAuthDialog = flg;
    },
    setSelectedCompany(com){
      this.selectedCompany = com;
    },
    setCompany(com){
      this.addPartUserCompany = com;
    },
    addOwnUser : async function(){
      //バリデーション
      if (!this.$refs.addOwnUserForm.validate()) {
        if(!this.addOwnUserEmail){
            this.$refs.MsgDlg.showError('メールアドレスを入力してください');
        } else if(!this.addOwnUserAuth){
            this.$refs.MsgDlg.showError('権限を選択してください');
        }
        return;
      }
      if(this.selectedCompanies.length === 0 && this.addOwnUserAuth !== Constant.UserAuthTypeDisp.Admin){
        this.$refs.MsgDlg.showError("アクセス権を設定してください");
        return;
      }
      
      //ボタン無効化
      this.loadingAddOwnUser = true;

      // フォルダ設定
      var auth_fold_id = [];
      for(var i = 0; i < this.selectedCompanies.length; i++) {
        auth_fold_id.push(this.selectedCompanies[i]);
      }
      // ユーザー追加
      var ownUserAuth = Constant.UserAuthType.General;
      if(this.addOwnUserAuth === Constant.UserAuthTypeDisp.Admin){
        ownUserAuth = Constant.UserAuthType.Admin;
        //管理者ならアクセス権Null
        auth_fold_id = null;
      }
      // ユーザー追加 メイン処理実行
      let _this = this;
      let user_uuid_id = Uuid.getUuid(); // 重複しないようにクライアントで生成
      await _this.addUserCore(user_uuid_id, this.addOwnUserEmail, ownUserAuth, auth_fold_id, this.addOwnUserMfaflg, Constant.UserType.Host).then(result => {
        // クライアントで生成したユーザーIDとチェック
        if(result.data.AddUser.user_id === user_uuid_id){
          _this.$refs.MsgDlg.showSuccess("招待メールを送信しました");
          _this.oCAddOwnUserDialog(false);
          _this.$refs.addOwnUserForm.reset();
          _this.selectedCompanies = [];
        }
      }).catch(error => {
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        _this.loadingAddOwnUser = false;
      });
      _this.loadingAddOwnUser = false;
    },
    addPartUser : async function(){
      //バリデーション
      if (!this.$refs.addPartUserForm.validate()) {
        if(!this.addPartUserEmail){
            this.$refs.MsgDlg.showError('メールアドレスを入力してください');
        }
        return;
      }
      //ボタン無効化
      this.loadingAddPartUser = true;
      // ユーザー追加 メイン処理実行
      let _this = this;
      let user_uuid_id = Uuid.getUuid(); // 重複しないようにクライアントで生成
      await _this.addUserCore(user_uuid_id, this.addPartUserEmail, Constant.UserAuthType.General, [this.addPartUserCompany], this.addPartUserMfaflg, Constant.UserType.Guest).then(result => {
        // クライアントで生成したユーザーIDとチェック
        if(result.data.AddUser.user_id === user_uuid_id){
          _this.$refs.MsgDlg.showSuccess("招待メールを送信しました");
          _this.oCAddPartUserDialog(false);
          _this.$refs.addPartUserForm.reset();
          _this.loadingAddPartUser = false;  
        }
      }).catch(error => {
        _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
        _this.loadingAddPartUser = false;
      });
    },
    // ユーザー追加メイン処理
    addUserCore : async function(user_id, email, auth_type, auth_fold_id, mfa_type, user_type){
      // ユーザー作成関数
      const addUserInput = {
        user_id : user_id,
        email : email,
        auth_type : String(auth_type),
        auth_fold_id : auth_fold_id,
        mfa_type : mfa_type ? Constant.UserMfa.On : Constant.UserMfa.Off,
        user_type : String(user_type),
      };
      Logger.log(addUserInput);
      let result = null;
      await GraphqlUtil.exec(Mutations.AddUser, {input: addUserInput}).then(result_tmp => {
        Logger.log(result_tmp);
        result = result_tmp;
      }).catch(error => {
        Logger.log(error);
        throw error;
      });
      return result;
    },
    //全選択
    selectAllCompanies(){
      this.companies.forEach(e => {
        this.selectedCompanies.push(e.id);
        e.children.forEach(e2 => {
          this.selectedCompanies.push(e2.id);
          e2.children.forEach(e3 => {
            this.selectedCompanies.push(e3.id);
          });
        });
      });
    },
    //フォルダ全選択
    selectAllChildCompanies(item){
      this.selectedCompanies.push(item.id);
      item.children.forEach(e2 => {
        this.selectedCompanies.push(e2.id);
        e2.children.forEach(e3 => {
          this.selectedCompanies.push(e3.id);
        });
      });
    },
    //フォルダ全解除
    clearAllChildCompanies(item){
      var index = this.selectedCompanies.indexOf(item.id);
      if(index !== -1){
        this.selectedCompanies.splice(index, 1);
      }
      item.children.forEach(e2 => {
        index = this.selectedCompanies.indexOf(e2.id);
        if(index !== -1){
          this.selectedCompanies.splice(index, 1);
        }
        e2.children.forEach(e3 => {
          index = this.selectedCompanies.indexOf(e3.id);
          if(index !== -1){
            this.selectedCompanies.splice(index, 1);
          }
        });
      });
    },
    
    //ユーザー削除 
    deleteOwnUser(item) {
      let _this = this;
      _this.checkDeleteItem().then(async function(ret) {
        if (ret) {
            let _result = null;
            await GraphqlUtil.exec(Mutations.DeleteUser, {user_id: item.ownUserUuId}).then(result => {
              _result = result;
              Logger.log(result);
            }).catch(error => {
              _result = null;
              Logger.log(error);
              _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
              _this.overlayUser = false;
            });

            if(!_result){
              _this.overlayUser = false;
              return;
            } 

            //画面処理
            const index = _this.ownUsers.indexOf(item);
            _this.ownUsers.splice(index, 1);
            _this.overlayUser = false;
          }
      })
    },
    deletePartUser(item) {
      let _this = this;
      this.checkDeleteItem().then(async function(ret) {
        if (ret) {
            let _result = null;
            await GraphqlUtil.exec(Mutations.DeleteUser, {user_id: item.partUserUuId}).then(result => {
              _result = result;
              Logger.log(result);
            }).catch(error => {
              _result = null;
              Logger.log(error);
              _this.$refs.MsgDlg.showError(Amplify.GetJaErrMsg(error));
              _this.overlayUser = false;
            });

            if(!_result){
              _this.overlayUser = false;
              return;
            }

            //画面処理
            const index = _this.partUsers.indexOf(item);
            _this.partUsers.splice(index, 1);
            _this.overlayUser = false;
          }
      })
    },

    //削除チェックダイアログ
    checkDeleteItem() {
      this.checkDeleteDialog = true;
      let _this = this;
      return new Promise(function (resolve) {
        _this.okCancelResolve = resolve;
      });
    },
    deleteOk(){
      this.okCancelResolve(true);
      this.overlayUser = true;
      this.checkDeleteDialog = false;
    },
    deleteCancel(){
      this.okCancelResolve(false);
      this.checkDeleteDialog = false;
    },
  }
};
</script>

<style>
</style>